import React from 'react'

function SchoolAdmissionPayment() {
  return (
    <div>SchoolAdmissionPayment</div>
  )
}

export default SchoolAdmissionPayment